import axiosConfig from '@lib/axiosConfig';

export const AuthService = {

    authenticate: async function (credentials) {
    	return await axiosConfig.post('/authenticate', credentials);
    },

};